import { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
  getNewsletter
} from './store/newsletter/actions';

import { setABLeg } from './utils/piwik';

export const useABTests = (tests) => {
  /**
   * Sets up ABtest
   * 
   * @param tests Tests configurations
   * A example tests param looks like 
      const tests = [
          {
            name: `testA`,
            variations: [
              {
                name: `original`
              },
              {
                name: `legBForTestA`
              }
            ]
          }
        ];
   * 
   * @return ABTests An object maps each test to a selected leg
   * e.g. {testA: `legA`, testB: `legB`}
   */
  const [ABTests, setABTests] = useState({});

  useEffect(() => {
    const setUpABLeg = (test) => {
      const leg = setABLeg({
        testName: test.name,
        variations: test.variations,
      });
      setABTests({
        ...ABTests,
        [test.name]: leg,
      });
    }

    tests.forEach(test => {
      setUpABLeg(test)
    });
  }, []);

  return ABTests;
}

export const useResize = (myRef) => {
  const [width, setWidth] = useState(0)
  const [height, setHeight] = useState(0)

  useEffect(() => {
    const handleResize = () => {
      setWidth(myRef.current.offsetWidth)
      setHeight(myRef.current.offsetHeight)
    };

    window.addEventListener('resize', handleResize)

    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [myRef])

  useEffect(() => {
    if (myRef.current) {
      setWidth(myRef.current.offsetWidth)
      setHeight(myRef.current.offsetHeight)
    }
  }, [myRef])

  return { width, height }
}

export const useNewsletterPreview = () => {
  const newsletter = useSelector(state => state.newsletter);
  const dispatch = useDispatch();

  useEffect(() => {
    if (newsletter === null) {
      dispatch(getNewsletter(
        `thequickscope.com`,
        `quickscope_daily`,
        `baseline-v1`,
      ));
    }
  }, []);

  return newsletter;
}